/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBonusCodeLookup.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/bonus-code-lookup";

export class AutogenModelBonusCodeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowBonusCodeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBonusCodeLookup extends ModelRow<RowBonusCodeLookupFields> {
	constructor(values?: Partial<RowBonusCodeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBonusCodeLookupFields {
	company_id: string;
	ded_401k: string;
	ded_credit_union: string;
	ded_prev_balance: string;
	descr: string;
	id: string;
	is_active: string;
	print_check: string;
}

